import gql from 'graphql-tag';

const uploadFileMutation = gql`
  mutation uploadFile($eventDomain: String!, $file: Upload!, $uniqueToken: String!) {
    uploadFile(input: {
      eventDomain: $eventDomain,
      file: $file,
      uniqueToken: $uniqueToken,
    }) {
      success
      attachment {
        id
        fileName
        contentType
        fileUrl
      }
    }
  }
`;

export default uploadFileMutation;
